// Environment-driven backend configuration. Mirrors the buildConfig fields in
// the Android app (BASE_URL / CABLE_URL / REPORT_URL).

export type VizzlyEnv = 'stage' | 'prod';

interface EnvConfig {
  baseUrl: string;
  cableUrl: string;
  reportUrl: string;
}

const CONFIGS: Record<VizzlyEnv, EnvConfig> = {
  stage: {
    baseUrl: 'https://device.stage.vizzly.net/',
    cableUrl: 'wss://device.stage.vizzly.net/cable',
    reportUrl: 'https://report.stage.vizzly.net/v1/display-logs',
  },
  prod: {
    baseUrl: 'https://device.vizzly.net/',
    cableUrl: 'wss://device.vizzly.net/cable',
    reportUrl: 'https://report.vizzly.net/v1/display-logs',
  },
};

const rawEnv = (import.meta.env.VITE_VIZZLY_ENV ?? 'stage').toLowerCase();
export const ACTIVE_ENV: VizzlyEnv = rawEnv === 'prod' ? 'prod' : 'stage';

export const env: EnvConfig = CONFIGS[ACTIVE_ENV];

// Sent in pairing/login payloads.
export const APP_VERSION = '1.0.2';
export const OS_NAME = 'Web';
